<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  {{ data.description }}
</mat-dialog-content>
<mat-dialog-actions>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button class="primary-button-dark" mat-stroked-button type="button" [mat-dialog-close]="true">Ja</button>
  <button class="secondary-button-dark" mat-stroked-button type="button" [mat-dialog-close]="undefined">Nein</button>

</mat-dialog-actions>